import { useEffect, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import { ActionBar, DashList, DataListWrap, Grid, GridItemCol1, GridItemCol2, GridItemTitle, GridItemTitleLeft, Img, ItemContent, LegendTag, LegendWrap, PickButton} from './StatisticsDetails.styled';
import moment from 'moment';
import { useStore } from '@store/appStore';
import db from '@utils/db';

import Note_Icon from "@assets/svg/notes.svg";
import Profile_Icon from "@assets/svg/profile.svg";
import PieGraph from '../Dashboard/PieGraph';

interface IProps { }

export const StatisticsDetails = (props: IProps) => {
  const {client } = useStore();
  
  return (<>
    <Grid>
        <GridItemCol1>
          <GridItemTitle>Dagens registreringer</GridItemTitle>

          
        </GridItemCol1>

        <GridItemCol1>
          <GridItemTitle>Fraværsårsager</GridItemTitle>


          <ItemContent>
            <PieGraph />
            
            <LegendWrap>
              <LegendTag color={"#000"}>Kommune <div /></LegendTag>
            </LegendWrap>
          </ItemContent>
        </GridItemCol1>
          
        <GridItemCol2>
          <GridItemTitleLeft>
            Fravær
            <button>Se detaljer</button>
          </GridItemTitleLeft>
          
        </GridItemCol2>

        <GridItemCol2>
          <GridItemTitleLeft>
            Heat map fravær
            <button>Se detaljer</button>
          </GridItemTitleLeft>

        </GridItemCol2>

      </Grid>
  </>);
};

export default StatisticsDetails;
